const lastCalled = new Map();

export function shouldThrottle(key, duration = 100) {
	const now = Date.now();
	const last = lastCalled.get(key) || 0;

	if (now - last < duration) {
		return true;
	}

	lastCalled.set(key, now);
	return false;
}
